import React, { useEffect, useState } from "react";
import { AiOutlineDelete, AiOutlineDownload } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import LoaderGlobal from "../../../../Components/Loader/LoaderGlobal";
import RenderLibrarySkeleton from "../../../../Components/SkeletonLoader/RenderLibrarySkeleton";
import {
  deleteRenders,
  downloadRender,
} from "../../../../Redux/actions/projectActions";
import { getProjects } from "../../../../Redux/actions/projectsActions";
import Navbar_render from "../Nav_render/Navbar_render";
import {
  getResolutionFromHeightAndWidth,
  getfpsFromNumAndDen,
} from "../render.constants";
import "./RenderLibrary.css";
import {
  Scrollx_animate,
  scrollxLogo,
  Sx_Download,
} from "../../../../assets/icons";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../../../Components/CustomToast/CustomToast";
import SuccessModal from "../../../Dashboard/SuccessModal";

const RenderLibrary = () => {
  const dispatch = useDispatch();
  const { allProjects } = useSelector((state) => state?.projects);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const navigate = useNavigate();

  const downLoadVideo = async (projectId, renderId, type) => {
    const urlRes = await dispatch(downloadRender(projectId, renderId, type));
    if (urlRes?.expired) {
      navigate("/render-download-unavailable?reason=expired");
      return;
    }
    if (urlRes?.success && urlRes?.data?.downloadURL) {
      window.open(urlRes.data.downloadURL);
      return;
    }
    toast.error("URL Not Exist");
  };

  // const deleteRender = (projectId, renderId) => {
  //   const confirm = window.confirm(
  //     `Are you sure! You want to delete Render (${renderId})?`
  //   );
  //   if (confirm) dispatch(deleteRenders(projectId, renderId));
  // };

  const deleteRender = (projectId, renderId) => {
    const handleConfirm = (closeToast) => {
      console.log(" 1  is Confirm");
      dispatch(deleteRenders(projectId, renderId));
      closeToast();
      setSuccessModal(true);
      setSuccessMsg(`Render has been successfully deleted.`);
    };

    toast(
      ({ closeToast }) => (
        <CustomToast
          title="Are you sure!"
          content={`You want to delete Render?`}
          onConfirm={() => handleConfirm(closeToast)}
          onCancel={closeToast}
        />
      ),
      defaultcustomToatStyle
    );
  };

  const rendersSkeleton = () => {
    let skeletons = [];
    for (let i = 0; i < 5; i++) {
      skeletons.push(<RenderLibrarySkeleton />);
    }

    return skeletons;
  };

  const closeModal = () => {
    navigate("/dashboard");
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getProjects()).then(() => {
      setLoading(false);
    });
  }, [dispatch, deleteRenders]);

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  return (
    <>
      <ToastContainer closeButton={CloseButton} />

      <div className="h-full">
        {successMsg && (
          <SuccessModal
            successModal={successModal}
            setSuccessModal={setSuccessModal}
            deleteMsg={successMsg}
          />
        )}
        <div className="renderLibraryDiv">
          <div className="navbarBg">
            <Navbar_render closeModal={closeModal} nameShow={"MY RENDERS"} />
          </div>

          {loading ? (
            <div className="text-white myRenderLoadingContainer bg-[#121212] flex justify-center items-center">
              <div className="modal-overlayMyRender">
                <img
                  className="absolute opacity-80 myRenderLoading"
                  src={Scrollx_animate}
                  width="120px"
                  height="120px"
                />
                <p className="mt-[8rem] text-[0.9rem]">Loading...</p>
              </div>
            </div>
          ) : (
            <div className="renderTable ">
              <div className="tblHead h-[55px]  w-full bg-[#333] text-white  shadow-md">
                <div className="manrope-400 text-[1rem] w-[15%] pl-[1.5%] ">
                  Project Name
                </div>
                <div className="manrope-400 text-[1rem] w-[15%] text-center ">
                  Date
                </div>

                <div className="manrope-400 text-[1rem] w-[10%] text-center ">
                  Type
                </div>

                <div className="manrope-400 text-[1rem] w-[12%] text-center ">
                  Resolution
                </div>
                <div className="manrope-400 text-[1rem] w-[10%] text-center">
                  Aspect Ratio
                </div>
                <div className="manrope-400 text-[1rem] w-[12%] text-center ">
                  Format
                </div>
                <div className="manrope-400 text-[1rem] w-[11%] text-center ">
                  FPS
                </div>

                <div className="manrope-400 text-[1rem] w-[9%] text-center ">
                  Download video
                </div>
                <div className="manrope-400 text-[1rem] w-[6%] text-center ">
                  Action
                </div>
              </div>

              <div className="tblBody">
                {!loading &&
                  allProjects.length > 0 &&
                  allProjects.map((project, index) => {
                    return (
                      <div
                        key={project._id}
                        className="w-full my-[1rem] text-white "
                      >
                        {project.renders.length > 0 && (
                          <div
                            className="py-3 text-2xl pl-6 bg-[#1E1E1E] my-[5px]"
                            style={{
                              border: "1px solid rgb(58 58 58)",
                              borderRadius: "10px",
                            }}
                          >
                            <h2 className="projectTitle  manrope-600 uppercase">
                              {project?.title}
                            </h2>
                          </div>
                        )}

                        <div className="w-full h-full">
                          <div className="w-full text-md manrop-400 3xl:text-md ">
                            {project?.renders
                              .slice()
                              .reverse()
                              .map((render, idx) =>
                                render && render?.isVideoGenerated ? (
                                  <div
                                    key={render._id}
                                    className="w-full tblRow mt-[1rem]"
                                  >
                                    <div
                                      key={idx}
                                      className=" h-[64px] manrop-400 w-[85%] test11 flex items-center flex-start ml-[15%] "
                                    >
                                      {/* <div className="w-[15%] "/> */}

                                      <div className="w-[17.5%] flex justify-center ">
                                        {new Date(
                                          render?.createdAt
                                        ).toDateString()}{" "}
                                        -{" "}
                                        {new Date(render?.createdAt)
                                          .toTimeString()
                                          ?.slice(0, 5)}
                                      </div>

                                      <div className="w-[12%] flex justify-center ">
                                        {project?.isCard ? "Card" : "Scroll"}
                                      </div>

                                      <div className="w-[14%] flex justify-center ">
                                        {getResolutionFromHeightAndWidth(
                                          render?.videoHeight,
                                          render?.videoWidth
                                        )}
                                      </div>

                                      <div className="w-[12%] flex justify-center ">
                                        {render?.aspectRatio}
                                      </div>

                                      <div className="w-[14.5%] flex justify-center ">
                                        {String(render?.format).substring(6)}
                                      </div>

                                      <div className="w-[12%] flex justify-center">
                                        {getfpsFromNumAndDen(
                                          render?.fpsNumerator,
                                          render?.fpsDenominator
                                        )}
                                      </div>

                                      <div className="w-[10.5%] flex justify-center ">
                                        {render?.isVideoGenerated ? (
                                          <span
                                            className="cursor-pointer "
                                            onClick={() =>
                                              downLoadVideo(
                                                project._id,
                                                render._id,
                                                project?.isCard ? "Card" : "Scroll"
                                              )
                                            }
                                          >
                                            {/* <AiOutlineDownload className="inline" size={20} /> */}
                                            <img
                                              className="w-[25px]"
                                              src={Sx_Download}
                                              alt=""
                                            />
                                          </span>
                                        ) : (
                                          <span className="cursor-wait">-</span>
                                        )}
                                      </div>

                                      <div className="w-[7.5%] flex justify-center">
                                        <span
                                          className="cursor-pointer"
                                          onClick={() =>
                                            deleteRender(
                                              project._id,
                                              render?._id
                                            )
                                          }
                                        >
                                          <AiOutlineDelete size={"25px"} />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : null
                              )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RenderLibrary;
